import { useEffect } from 'react';
import { useGetActiveRoute } from '../../services';
import { ROUTE_TYPES } from '@wareclouds/frontend-common/b2c';
import { useDispatch } from 'react-redux';
import { setActiveRoute, setRouteType } from '../../routeSlice';

export default function useSyncActiveRouteToStore() {
  const dispatch = useDispatch();

  const {
    data: activeRouteData,
    isSuccess: isSuccessActiveRoute,
    isError: isErrorActiveRoute,
  } = useGetActiveRoute({ routeType: ROUTE_TYPES.SAME_DAY });

  useEffect(() => {
    if (isSuccessActiveRoute) {
      const activeRoute = activeRouteData?.data?.routes[0];
      dispatch(setRouteType(activeRoute?.route_type || ROUTE_TYPES.SAME_DAY));
      dispatch(
        setActiveRoute({
          routeType: activeRoute?.route_type || ROUTE_TYPES.SAME_DAY,
          idRoute: activeRoute?.id_route,
        })
      );
    }

    if (isErrorActiveRoute) {
      dispatch(setRouteType(ROUTE_TYPES.SAME_DAY));
      dispatch(
        setActiveRoute({ routeType: ROUTE_TYPES.SAME_DAY, idRoute: undefined })
      );
    }
  }, [
    isSuccessActiveRoute,
    dispatch,
    activeRouteData?.data?.routes,
    isErrorActiveRoute,
  ]);
}
